/**
 * User: mphee
 * Date: 11/24/12
 * Time: 10:45 AM
 */

define(function (require) {
    var BaseModel = require('common/models/OEBaseModel'),
        _ = require('underscore'),
        DateTZ = require('tzdate');
    
    return BaseModel.extend({
        'urlRoot': '/stu/info',
        'cacheKey': 'person'
    });
});


//////////////////
// WEBPACK FOOTER
// ./js/common/models/Student.js
// module id = 1115
// module chunks = 27 28 29